import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import accountShippingTerm from "@tKgpco/utilities/accountShippingTermCondition";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: ApplicationState) => {
    const { session } = state.context;
    const billTo = getBillToState(state, session.billToId).value;
    return {
        deliveryTerms: billTo?.properties?.deliveryTerms || "",
    };
}

export interface AccountShippingTermStyles {
    termLabel?: TypographyPresentationProps;
    termValue?: TypographyPresentationProps;
    wrapper?: InjectableCss;
}

export const AccountShippingTermStyles: AccountShippingTermStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    termLabel: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.bold};
            margin-right: 5px;
        `,
    },
    termValue: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
        `,
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = AccountShippingTermStyles;
const AccountShippingTerm = ({ deliveryTerms }: Props) => {

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.termLabel}>{siteMessage("Account_Shipping_Terms")}</Typography>
            <Typography {...styles.termValue}>{accountShippingTerm(deliveryTerms)}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AccountShippingTerm),
    definition: {
        displayName: "Account Shipping Term",
        group: "Checkout - Review & Submit",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
    },
};

export default widgetModule;
